import React from 'react';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import { AppImage } from '../AppImage';
import { workHeroImage } from '../../data/workImages';
export function WorkHero() {
  return <section className="bg-canvas pb-16 pt-[96px] lg:pb-20 lg:pt-[152px]" data-id="element-906" data-mp="1519ysk62y7a0">
      <Container data-id="element-907" data-mp="1a164qoyc88s7">
        <Reveal data-id="element-908" data-mp="1a0mk30haz6ah">
          <p className="text-small text-muted" data-id="element-909" data-mp="1a04pe8aah04o">Work / 2026</p>
          <h1 className="mt-5 max-w-[20ch] font-serif text-[clamp(40px,5vw,72px)] font-normal leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-910" data-mp="v4f46ccxgr10">
            Every project here was designed, written and built in the studio, end to end.
          </h1>
          <p className="mt-8 max-w-[52ch] border-t border-hairline pt-6 text-body text-muted" data-id="element-911" data-mp="m51rlatibmc2">
            Every project below is self-initiated concept work, and labelled as such. No client
            commissioned them — judge the thinking, not the logo.
          </p>
          <AppImage src={workHeroImage.image} alt={workHeroImage.alt} ratio="16:10" className="mt-12 lg:mt-16" data-id="element-912" data-mp="2lgurpgbld7t0" />
        </Reveal>
      </Container>
    </section>;
}